/**
 * Vendor search API.
 */

import { apiFetch } from './fetch';
import { API } from '../constants';

export interface VendorSearchResult {
    id: string;
    name: string;
    code?: string;
}

/** Search vendors by name (contains). Supports AbortSignal for cancellation. */
export async function searchVendors(query: string, signal?: AbortSignal): Promise<VendorSearchResult[]> {
    const opts: RequestInit = {};
    if (signal) {
        opts.signal = signal;
    }
    const result = await apiFetch<VendorSearchResult[]>(
        `${API.VENDORS}/search?filter=${encodeURIComponent(query)}`,
        opts,
    );
    return Array.isArray(result) ? result : [];
}
